export const editableMenuList = [
  {
    label: "应用管理",
    value: "admin-app",
    icon: "admin-app",
    children: [
      {
        label: "应用信息",
        value: "admin-app-info"
      },
      {
        label: "应用操作",
        value: "admin-app-operation"
      },
      {
        label: "群机器人",
        value: "admin-app-robot"
      }
    ]
  },
  {
    label: "工作表",
    value: "admin-sheet",
    icon: "admin-sheet"
  },
  {
    label: "工作流",
    value: "admin-workflow",
    icon: "admin-workflow"
  },
  {
    label: "互联管理",
    value: "sync-rule",
    icon: "admin-sync-rule",
    children: [
      {
        label: "主规则",
        value: "admin-sync-rule-master"
      },
      {
        label: "从规则",
        value: "admin-sync-rule-slave"
      },
      {
        label: "同步记录",
        value: "admin-sync-log"
      }
    ]
  },
  {
    label: "展示管理",
    value: "display",
    icon: "display",
    children: [
      {
        label: "菜单设置",
        value: "admin-menu-display"
      }
    ]
  },
  {
    label: "模板管理",
    value: "template",
    icon: "template",
    children: [
      {
        label: "打印模板",
        value: "admin-print-template"
      },
      {
        label: "导出模板",
        value: "admin-export-template"
      }
    ]
  },
  {
    label: "看板管理",
    value: "admin-statistics",
    icon: "admin-statistics",
    children: [
      {
        label: "看板管理",
        value: "admin-statistics-board"
      },
      {
        label: "自动取数",
        value: "admin-statistics-auto-count"
      }
    ]
  },
  {
    label: "数据管理",
    value: "admin-data",
    icon: "admin-data",
    children: [
      {
        label: "回收站",
        value: "admin-data-recycle"
      }
    ]
  },
  {
    label: "角色权限",
    value: "admin-pri",
    icon: "admin-pri",
    children: [
      {
        label: "应用角色",
        value: "admin-role"
      },
      {
        label: "应用成员",
        value: "admin-member"
      }
    ]
  }
]

export const uneditableMenuList = [
  {
    label: "应用管理",
    value: "admin-app",
    icon: "admin-app",
    children: [
      {
        label: "应用信息",
        value: "admin-app-info"
      }
    ]
  },
  {
    label: "互联管理",
    value: "sync-rule",
    icon: "admin-sync-rule",
    children: [
      {
        label: "同步记录",
        value: "admin-sync-log"
      }
    ]
  },
  {
    label: "数据管理",
    value: "admin-data",
    icon: "admin-data",
    children: [
      {
        label: "回收站",
        value: "admin-data-recycle"
      }
    ]
  },
  {
    label: "角色权限",
    value: "admin-pri",
    icon: "admin-pri",
    children: [
      {
        label: "应用角色",
        value: "admin-role"
      },
      {
        label: "应用成员",
        value: "admin-member"
      }
    ]
  }
]
